module.exports = __webpack_public_path__ + "img/Creditos.04b53aa5.svg";